import moment from 'moment'
import { initializeApp } from "firebase/app"
import { getDatabase, ref, update} from "firebase/database"
import {
  getAuth,
  signOut,
} from "firebase/auth"

import ApiService from './ApiService'

class FirebaseService {
  constructor () {
    console.log('CONSTRUCT GLOBAL FirebaseService')
    this.fbDatabase = null
    this.path = `users/$cpf/telessaude/sala/$cpf`
    this.pathLog = `telessaude-log/$cpf/`
    this.setFirebaseConfig()
    this.ApiService = new ApiService()
  }

  /**
   * Configura a conexão com o Firebase.
   */
  setFirebaseConfig () {
    const config = {
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.VUE_APP_FIREBASE_APP_ID
    }
    const firebaseApp = initializeApp(config)
    this.fbDatabase = getDatabase(firebaseApp)
    this.fbAuth = getAuth(firebaseApp)
  }

  /**
   * Atualiza uma chave específica na sala do Firebase com base no CPF fornecido.
   * @param {string} cpf - O CPF do usuário, contendo pontos e traços (que serão removidos).
   * @param {string} key - A chave específica a ser atualizada no Firebase.
   * @param {*} value - O valor a ser aplicado à chave.
   * @returns {Promise<boolean>} Retorna `true` se a atualização for bem-sucedida, caso contrário, `false`.
  */
  async updateFirebaseRoom (cpf, key, value) {
    const cpfFormat = cpf.replace(/[.-]/g, '')
    const path = `${this.path.replace(/\$cpf/g, cpfFormat)}/agoraSdk`
    const payload = {
      [key]: value,
      updated_at: moment().format('DD/MM/YYYY - HH:mm:ss') // Atualiza também a data de modificação
    }  
    update(ref(this.fbDatabase, path), payload)
    .then(async () => {
      console.info(`[GLOBAL updateFirebaseRoom] Chave ${key} atualizada com sucesso`)
      return true
    })
    .catch((error) => {
      console.error(`[GLOBAL updateFirebaseRoom] Erro ao atualizar a chave ${key}:`, error)
      return false
    })
  }
  async logout() {
    await signOut(this.fbAuth);
  }
}

export default FirebaseService